import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    DrawerWrapper: {
        width: "35vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f6fa",
        padding: "16px",
    },
    OrderItems: {
        marginBottom: "12px",
        "& .Orders__List": {
            "& .Orders__List_RowWrapper": {
                display: "flex",
                alignItems: "center",
            },
            "& .Orders__List_header": {
                padding: "0.5rem 17px",
                fontWeight: "900",
                marginBottom: 0,
                "&>div": {
                    flex: 1,
                },
            },
            "& .Orders__List_item": {
                "&>div": {
                    flex: 1,
                    marginRight: "0.5rem",
                },
                "&:hover": {
                    color: "#FFFFFF",
                    background: "#e14954",
                    cursor: "pointer",
                },
            },
            "&>div >div": {
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "14px",
                lineHeight: "17px",
                color: "#e14954",
                padding: "17px",
                background: "#FFFFFF",
                borderRadius: "8px",
                marginBottom: "8px",
                transition: "0.2s all",
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
            },
            "& .subtext": {
                fontSize: "xx-small",
                display: "flex",
                alignItems: "center",
            },
            "& .selected": {
                color: "#FFFFFF",
                background: "#e14954",
            },
        },
        "& .Orders__List.md": {
            maxHeight: "50vh",
            height: "auto",
            overflowY: "auto",
        },
    },
    ListItem: {
        display: "flex",
    },
}));
